export default {
  state: {
    tokenBearer: ""
  },
  mutations: {
    setTokenBearer(state, _token) {
      localStorage.setItem("tokenBearer", _token);
      state.tokenBearer = _token;
    },
    deleteTokenBearer() {
      localStorage.removeItem("tokenBearer");
    },
    setNewAuthToken(state, _newToken) {
      localStorage.setItem("tokenBearer", _newToken);
      state.tokenBearer = _newToken;
    },
    recuperarToken(state) {
      let token = localStorage.getItem("tokenBearer");
      if (![null, undefined].includes(token)) {
        state.tokenBearer = token;
      }
    }
  },
  actions: {
    resetarLocalStorage({ commit }) {
      commit("deleteUsuario");
      commit("deletePermissoes");
      commit("deleteTokenBearer");
    }
  },
  getters: {
    getTokenBearer: state => state.tokenBearer
  }
};
